export enum PreQualifierProductLocalStorage {
  VENDOR_ID = 'VENDOR_ID',
  PRODUCT_ID = 'PRODUCT_ID',
}
